module.exports = __webpack_public_path__ + "static/media/reflector.2e66ce04.png";